// extracted by mini-css-extract-plugin
module.exports = {"doodle0":"Doodle_doodle0__2g4Fv","doodle1":"Doodle_doodle1__uX3Vr","doodle2":"Doodle_doodle2__4E5Vl","doodle3":"Doodle_doodle3__pX5la"};